import './new-util-age-bracket.scss';

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormUtilAgeBracket from "../form-util-age-bracket/form-util-age-bracket";
import { useNewUtilAgeBracket } from './new-util-age-bracket.hook';

export function NewUtilAgeBracket() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewUtilAgeBracket();

  return (
    <div id="NewUtilAgeBracket" className="util-age-bracket">
      <HeaderContent
        title={<h1>New Util Age Bracket</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormUtilAgeBracket />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewUtilAgeBracket;